import { v4 as uuidv4 } from 'uuid';
import { PageType } from "@zotlo-shared/types/model";
import { getClientCookie, setClientCookie, deleteClientCookie, COOKIE, getTimeAsUTC, generateExpireTime } from '#shared/utils/cookie';
import { canViewable } from '#shared/utils/session';

export function getVisitedPages() {
  return JSON.parse(getClientCookie(COOKIE.VISITED) || '[]');
}

export function setVisitedPages(pageType: PageType) {
  const { siteData, isSandbox } = useSiteDataOnClient()
  const isPreview = siteData.value.preview;
  if (!canViewable({
      pageType,
      siteData: siteData.value,
      cookies: getSessionCookiesOnClient()
    }) || (isPreview && !isSandbox.value)) return;

  const visitedPages = getVisitedPages();
  const route = useRoute();
  const { slug } = getBaseUrl(route?.fullPath);

  if (!visitedPages.includes(pageType)) {
    visitedPages.push(pageType);
    const expireAt = siteData.value?.expireAt || getClientCookie(COOKIE.EXPIRE_AT);
    const date = new Date(getTimeAsUTC(expireAt || ''));
    setClientCookie(
      COOKIE.VISITED,
      JSON.stringify(visitedPages),
      date,
      slug
    );
  }
}

export function getFirstPageOnClient() {
  const { siteData } = useSiteDataOnClient();
  return getFirstPage(siteData.value, getSessionCookiesOnClient());
}

export function isSessionExpired(customExpireAt?: string) {
  const { siteData } = useSiteDataOnClient();
  const expireAt = customExpireAt || siteData.value?.expireAt || getClientCookie(COOKIE.EXPIRE_AT);
  const isExpired = getTimeAsUTC() > getTimeAsUTC(expireAt || '');
  if (isExpired) {
    const route = useRoute();
    const { slug } = getBaseUrl(route?.fullPath);
    reloadSessionId(undefined, slug);
    return isExpired;
  }
  return false;
}

export function checkCurrentSession() {
  if (isSessionExpired()) {
    globalThis?.location?.reload();
    return true;
  }

  return false;
}

export function reloadSessionId(isPreview?: boolean, path?: string) {
  deleteClientCookie(COOKIE.VISITED, path);
  deleteClientCookie(COOKIE.COUNTDOWN_STARTED_AT, path);
  setClientCookie(
    COOKIE.SESSION_ID,
    `${uuidv4()}${isPreview ? ';SameSite=None; Secure' : ''}`,
    generateExpireTime().date,
    path
  );
}
